import { Typography } from '@weareopenr/component-library';
import styles from './NoResultsEmptyState.module.scss';

interface NoResultsEmptyStateProps {
  className?: string;
}

export const NoResultsEmptyState = ({ className }: NoResultsEmptyStateProps) => (
  <div className={`${styles['no-results']} ${className || ''}`}>
    <Typography>No results found</Typography>
  </div>
);
